export class Snackbar {
    public readonly SNACKBAR_SELECTOR = '#checkout-snackbar-error';
    public readonly snackbarElement: HTMLOcSnackbarV1Element | null = null;

    constructor() {
        this.snackbarElement = document.querySelector<HTMLOcSnackbarV1Element>(this.SNACKBAR_SELECTOR);
    }

    showMessage(message: string = 'Entschuldigung, es ist ein Fehler aufgetreten.'): void {
        if (this.snackbarElement) {
            this.snackbarElement.setAttribute('message', message);
            this.snackbarElement.setAttribute('open', 'true');
        } else {
            window.otto.components.snackbarV1.push(message);
        }
    }
}
